import { type Action, Actions, type State } from '../types';

export function stateReducer(state: State, action: Action): State {
  switch (action.type) {
    case Actions.SET_MODAL_OPEN:
      return { ...state, isModalOpen: action.payload };
    case Actions.SET_PRODUCT_TYPE:
      return { ...state, productType: action.payload };
    case Actions.SET_SALES_PRICE:
      return { ...state, salesPrice: action.payload };
    case Actions.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case Actions.SET_ENTRY:
      return { ...state, entry: action.payload, fetched: true };
    case Actions.SET_CURRENT_STEP:
      return { ...state, currentStep: action.payload };
    case Actions.SET_SELECTED_BRAND:
      return { ...state, selectedBrand: action.payload };
    case Actions.SET_SELECTED_VARIANT:
      return { ...state, selectedVariant: action.payload };
    case Actions.SET_VARIANT_CHOICES:
      return { ...state, variantChoices: action.payload };
    case Actions.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.payload };
    case Actions.SET_ANSWER:
      return typeof action.payload.questionId === 'undefined'
        ? state
        : {
            ...state,
            summary: null,
            answers: { ...state.answers, [action.payload.questionId]: action.payload.answer }
          };
    case Actions.SET_ANSWERS:
      return { ...state, answers: action.payload };
    case Actions.SET_SUMMARY:
      return { ...state, summary: action.payload };
    case Actions.SET_ENTRANCE_CHOICE:
      return { ...state, entranceChoice: action.payload };
    case Actions.SET_EXPLANATION_INFO:
      return { ...state, explanationInfo: action.payload };
    case Actions.SET_EXPLANATION_MODAL:
      return { ...state, isExplanationModalOpen: action.payload };
    default:
      return state;
  }
}
